import React from 'react';
import '../styles/ExitMessage.css';

interface ExitMessageOverlayProps {
  show: boolean;
  message: string;
}

const ExitMessageOverlay: React.FC<ExitMessageOverlayProps> = ({ show, message }) => {
  if (!show) return null;

  return (
    <div className="exit-message-toast">
      <div className="exit-message">
        {message}
      </div>
    </div>
  );
};

export default ExitMessageOverlay;
